// ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ allowedRoles = [], mobileLoginRequired = false, mobileLoginRules = {}, children}) => {
    const { loginState, loginUserInfo, isMobileLogin } = useSelector((state) => state.auth);

    // 로그인 상태 체크
    if (!loginState) {
        return <Navigate to="/login" replace />;
    }

    const userPermId = loginUserInfo.user?.perm_id;

    // 권한 체크 (allowedRoles가 있는 경우에만)
    if (allowedRoles.length > 0) {
        const hasRoleAccess = allowedRoles.includes(userPermId);
        if (!hasRoleAccess) {
            return <Navigate to="/forbidden" replace />;
        }
    }

    // 역할별 모바일 조건 체크 (mobileLoginRules가 있는 경우)
    if (mobileLoginRules && Object.keys(mobileLoginRules).length > 0) {
        const roleMobileRule = mobileLoginRules[userPermId];
        
        // 해당 역할에 대한 모바일 규칙이 정의된 경우
        if (roleMobileRule !== undefined) {
            // false: 모바일이 아닌 경우만 접근 가능
            // true: 모바일인 경우만 접근 가능
            if (roleMobileRule !== isMobileLogin) {
                return <Navigate to="/forbidden" replace />;
            }
        }
    }
    // 기존 mobileLoginRequired 체크 (하위 호환성)
    else if (mobileLoginRequired !== undefined) {
        if (mobileLoginRequired && !isMobileLogin) {
            return <Navigate to="/forbidden" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
